<template>
  <div
    :class="_class"
    :value="value"
  >
    <!-- @slot @ignore -->
    <slot />
  </div>
</template>
<script>
const name = 'ten-radio-group';

export default {
  name,
  provide() {
    return {
      group: this,
    };
  },
  inject: {
    formItem: {
      from: 'tenFormItem',
      default: null,
    },
  },
  props: {
    /**
     * @model
     *
     * value
     */
    value: [String, Number, Boolean],
    /**
     * @model
     *
     * 默认 value
     */
    defaultValue: [String, Number, Boolean],
    /**
     * 是否禁用
     */
    disabled: Boolean,
    /**
     * radio 类型
     * @member default | button
     */
    type: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    _class() {
      return [
        `${name}`,
        {
          'ten-radio-btn-group': this.type === 'button',
          'ten-button-group': this.type === 'button',
        },
      ];
    },
  },
  mounted() {
    this.$on('memberChange', this.onMemberChange);
  },
  methods: {
    onMemberChange({ value, checked }) {
      if (checked && this.value !== value) {
        /**
         * 选中值发生变化
         * @param { value } 选中值
         */
        this.$emit('change', value);
        this.formItem && this.formItem.$emit('form.change');
      }
    },
  },
};
</script>
